module.exports = __webpack_public_path__ + "static/media/bg-cloud.c413f8d9.png";